/* eslint-disable jsx-a11y/no-autofocus */
import classNames from 'classnames';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './Input.module.scss';
const Input = forwardRef(({ size = 's', shape = 'block', color = 'primary', disabled = false, placeholder = '', type = 'text', min, required, leftIcon, loading = false, suffix, name, value, autoFocus, testId, error, onChange, onFocus, onBlur, onKeyDown, }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const internalRef = useRef(null);
    const inputRef = ref || internalRef;
    const inputClasses = classNames(styles.input, styles[size], styles[shape], styles[color], {
        [styles.withLeftIcon]: leftIcon,
        [styles.error]: error,
    });
    useEffect(() => {
        if (!autoFocus)
            return undefined;
        const timer = setTimeout(() => {
            if ('current' in inputRef && inputRef.current) {
                inputRef.current.focus();
            }
        }, 10);
        return () => clearTimeout(timer);
    }, [autoFocus, inputRef]);
    const handleFocus = () => {
        setIsFocused(true);
        if (onFocus) {
            onFocus();
        }
    };
    const handleBlur = () => {
        setIsFocused(false);
        if (onBlur) {
            setTimeout(() => onBlur(), 300);
        }
    };
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("input", { type: type, name: name, value: value, placeholder: placeholder, min: min, required: required, className: inputClasses, "data-test": testId, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: onKeyDown, disabled: disabled, autoComplete: "off", autoFocus: autoFocus, ref: inputRef }),
        leftIcon && React.createElement("div", { className: styles.leftIcon }, leftIcon),
        loading && isFocused && (React.createElement("div", { className: styles.loadingIcon },
            React.createElement(LoaderSvg, null))),
        suffix && React.createElement("span", { className: styles.suffix }, suffix)));
});
export default Input;
